import { detailedStockValidate } from "../../application/dtos/detailed_stock_validate";

export class DetailedStockEntity {
    constructor({id, quantity, damaged, quarantine, sku}){
        this.id = id;
        this.quantity = quantity;
        this.damaged = damaged;
        this.quarantine = quarantine;
        this.sku = sku;
    }

    isValid() {
        return detailedStockValidate(this);
    }
}